import { render, staticRenderFns } from "./NotificationView.vue?vue&type=template&id=6124bf21&scoped=true&lang=pug&"
import script from "./NotificationView.vue?vue&type=script&lang=js&"
export * from "./NotificationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6124bf21",
  null
  
)

export default component.exports